import React from "react";
import styled from "styled-components";
import Filters from "./Filters";
import Text from "../shared/Text";
import Icon from "../shared/Icon";
import { useSpring, animated } from "react-spring";

interface FilterProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileFiltersWrapper: React.FC<FilterProps> = props => {
  const { y } = useSpring({
    from: { y: "100%" },
    y: props.isOpen ? "0%" : "100%"
  });

  return (
    <Wrapper
      style={{
        transform: y.interpolate(y => `translateY(${y})`)
      }}
    >
      <FiltersHeader>
        <Text className="label">Show / Hide:</Text>
        <Icon icon="close" size={20} onClick={props.onClose} />
      </FiltersHeader>
      <Filters />
    </Wrapper>
  );
};

const Wrapper = styled(animated.div as any)`
  flex-direction: column;
  justify-content: center;
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  position: fixed;
  bottom: 0px;
  width: 100%;
  z-index: 75;
  background: white;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  user-select: none;
  @media (min-width: 960px) {
    display: none;
  }
  > div {
    padding: 0.5rem 1rem;
  }
`;

const FiltersHeader = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  user-select: none;
`;

export default MobileFiltersWrapper;
